import type { TOC } from '@ember/component/template-only';

import MetricsPageComponent from 'webapp/components/metrics/page';

const MobileMetricsRouteTemplate: TOC<object> = <template><MetricsPageComponent /></template>;

export default MobileMetricsRouteTemplate;
